import { Helmet } from 'react-helmet-async';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export interface SEOProps {
  title: string;
  description: string;
  keywords?: string;
  ogImage?: string;
  ogUrl?: string;
  canonicalUrl?: string;
  type?: 'website' | 'article';
  publishedTime?: string;
  modifiedTime?: string;
}

const SEO = ({ 
  title, 
  description, 
  keywords = '', 
  ogImage = 'https://d2qb2qddg7l6c6.cloudfront.net/assets/images/legittmateAI_logo.png',
  ogUrl = 'https://legittmateai.com',
  canonicalUrl,
  type = 'website',
  publishedTime,
  modifiedTime
}: SEOProps) => {
  const location = useLocation();
  const siteTitle = 'Legitt Mate AI';
  const fullTitle = title === 'Home' ? siteTitle : `${title} | ${siteTitle}`;
  const currentUrl = `${ogUrl}${location.pathname}`;

  // Debug log in development
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.group('SEO Meta Tags');
      console.log('Path:', location.pathname);
      console.log('Title:', fullTitle);
      console.log('Description:', description);
      console.log('Keywords:', keywords);
      console.log('OG Image:', ogImage);
      console.log('Type:', type);
      console.groupEnd();
    }
  }, [location.pathname, fullTitle, description, keywords, ogImage, type]);

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl || currentUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={`${ogUrl}${ogImage}`} />
      <meta name="google-site-verification" content="qwaBX5Vyb73B0CFkvWH65L8j4ng8sB_fgjWn6wJPUMM" />
      
      {/* Article specific tags */}
      {type === 'article' && publishedTime && (
        <meta property="article:published_time" content={publishedTime} />
      )}
      {type === 'article' && modifiedTime && (
        <meta property="article:modified_time" content={modifiedTime} />
      )}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={`${ogUrl}${ogImage}`} />
    </Helmet>
  );
};

export default SEO; 